import { FC, useEffect, useState } from "react";
import { PageHeadMedia } from "../../../components/layout";
import { LatestNewsWidget } from "../../../widgets/news/LatestNews";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { TeamContext } from "../../../types/common";
import { getNewsItem, getNewsItemByName } from "../../../api/transport/newsTransport";
import { NewsDto } from "../../../types/news";
import { getStaticUrl, getUrlByContext } from "../../../utils";
import { NewsPhotos } from "./NewsPhotos";
import { SocialShare } from "../../../widgets/social/SocialShare";
import { Loader } from "../../../components/Loader";
import { getFixtureLinks } from "../../../api/transport/common";
import { NewsMatchLinks } from "./NewsMatchLinks";
import { MatchLinks } from "../../../types/fixtures";
import { useParams } from "react-router";

const NewsItemPage: FC = () => {
    const config = useConfiguration();
    const params = useParams();

    const newsUrl = config.standalone ? params.newsUrl : globalThis?.location?.pathname?.split('/news/')?.[1];

    const [newsData, setNewsData] = useState<NewsDto>(null);
    const [matchInfo, setMatchInfo] = useState<MatchLinks>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!newsUrl) {
            return;
        }

        setLoading(true);

        const match = globalThis?.location?.pathname?.match(/(\d+)-/);
        const newsId = match?.[1] || 0;

        const req = newsId ? getNewsItem(+newsId, config.site) : getNewsItemByName(newsUrl.split('/')[0], config.site);
        req.then(n => {
            setNewsData(n);
        }).finally(() => {
            setLoading(false);
        });

    }, [newsUrl]);

    useEffect(() => {
        if (!newsData?.matchId) {
            return;
        }

        getFixtureLinks(newsData.matchId).then(data => setMatchInfo({
            ...data,
            reportUrl: getUrlByContext(`/matches/matchcenter/${newsData.matchId}/`, config.teamName),
        }));
    }, [newsData]);

    let relatedCategory;

    if (config.teamName === TeamContext.RODINA_2) {
        relatedCategory = 8;
    } else if (config.teamName === TeamContext.RODINA_M) {
        relatedCategory = 6;
    }

    if (loading) {
        return (
            <div className="bg-white w-full h-screen">
                <Loader />
            </div>
        )
    }

    const publishDate = new Date(newsData?.date);
    const isInFuture = publishDate > new Date();

    return (
        <article className="bg-white">
            <PageHeadMedia
                mediaUrl={getStaticUrl(newsData?.image)}
            />
            <div className="max-w-[840px] mx-auto">
                <div className="p-2">
                    <h1 className="text-xl sm:text-3xl font-bold text-center py-2">{newsData?.title}</h1>
                    <div className="flex flex-row items-center text-lg gap-1 pt-2">
                        <svg className="w-6 h-6 text-inherit" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                        </svg>
                        {!isInFuture && <span>{publishDate.toLocaleDateString('ru-RU', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                            weekday: 'long'
                        })}</span>}
                        {isInFuture && <span>Будет опубликовано {publishDate.toLocaleDateString('ru-RU', {
                            day: 'numeric',
                            month: 'long',
                            //year: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                        })}</span>}
                    </div>
                    {matchInfo && <div className="py-3">
                        <NewsMatchLinks {...matchInfo} />
                    </div>}
                    <div
                        dangerouslySetInnerHTML={{
                            __html: newsData?.description
                        }}
                        className="fcr-article w-full max-w-full sm:py-4 text-xl"
                    />
                </div>
                {newsData && <div className="p-2 pb-8">
                    <div className="flex flex-row gap-2 items-center text-xl py-3 border-0  border-solid border-slate-200">
                        <div>Рассказать друзьям:</div>
                        <SocialShare
                            title={newsData?.title}
                            description={newsData?.title}
                            imageUrl={newsData?.image}
                            url={globalThis.location.href}
                            keys={['vk', 'telegram', 'whatsapp', 'twitter']}
                            iconClassName="!w-9 !h-9"
                        />
                    </div>
                </div>}
                <div className="p-2">
                    <NewsPhotos linkUrl={newsData?.photoGallery?.url} photos={newsData?.photoGallery?.photos} />
                </div>
            </div>
            {!loading && <div className="p-2 w-full">
                <LatestNewsWidget
                    category={relatedCategory}
                    newsId={newsData?.id}
                />
            </div>}
        </article>
    )
}

export default NewsItemPage;